import { render, staticRenderFns } from "./MastitisMilkQuality.vue?vue&type=template&id=bf82ddce&"
import script from "./MastitisMilkQuality.vue?vue&type=script&lang=js&"
export * from "./MastitisMilkQuality.vue?vue&type=script&lang=js&"
import style0 from "./MastitisMilkQuality.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports